export default __webpack_public_path__ + "static/media/HARYANA-8.08b4eb42.webp";